import { render, staticRenderFns } from "./NewClientModal.vue?vue&type=template&id=a4449d56&scoped=true&"
import script from "./NewClientModal.vue?vue&type=script&lang=js&"
export * from "./NewClientModal.vue?vue&type=script&lang=js&"
import style0 from "./NewClientModal.vue?vue&type=style&index=0&id=a4449d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4449d56",
  null
  
)

export default component.exports